'use client';

import { clsx } from 'clsx';
import { FC, Fragment, ReactHTMLElement } from 'react';
import { LandingImageTextStoryblok } from 'storyblok-types';
import { Container } from 'atoms/Container';
import { Picture } from 'atoms/Picture';
import { StoryBlokLink } from 'atoms/StoryBlokLink';
import { Body, HeadLine } from 'atoms/Typography/Typography';
import { RichTextMarkdown } from 'pages/StoryBlok/RichText';
import styles from './styles.module.css';

export const LandingImageText: FC<{ blok: LandingImageTextStoryblok }> = ({
  blok,
}) => {
  return (
    <Container
      className={clsx(
        styles.root,
        blok?.reverse && styles.rootReverse,
        blok?.vertical_align_center && styles.alignCenter,
        blok?.small_container && styles.smallContainer,
      )}
      style={{ backgroundColor: blok?.background?.color }}
    >
      {!!blok?.images?.length && (
        <div className={styles.images}>
          {blok.images.map((image) => {
            const renderImage = (
              <Picture
                srcDesktop={image?.desktop}
                srcMobile={image?.mobile}
                className={styles.image}
              />
            );

            return (
              <Fragment key={image._uid}>
                {!!image?.link?.url?.length ? (
                  <StoryBlokLink link={image.link} className={styles.link}>
                    {renderImage}
                  </StoryBlokLink>
                ) : (
                  renderImage
                )}
              </Fragment>
            );
          })}
        </div>
      )}

      <div className={styles.textBlock}>
        <RichTextMarkdown
          text={blok.text}
          components={{
            h2: ({ children }) => (
              <HeadLine
                type="sm"
                tag="h2"
                weight="bold"
                color="purple"
                className={styles.h2}
              >
                {children}
              </HeadLine>
            ),
            h3: ({ children }) => (
              <HeadLine
                type="xs"
                tag="h3"
                weight="bold"
                color="purple"
                style={
                  (children as ReactHTMLElement<HTMLElement>)?.props?.style
                }
                className={styles.h3}
              >
                {children}
              </HeadLine>
            ),
            p: ({ children }) =>
              children ? (
                <Body type="lg" weight="medium" className={styles.text}>
                  {children}
                </Body>
              ) : null,
          }}
        />
      </div>
    </Container>
  );
};
